import { Component, OnInit } from '@angular/core';
import { Exposer } from './components/exposer.component';
import { Module } from './components/module.component';
import { HostListener } from '@angular/core';
import { BootstrapGrowlService, BootstrapAlertType} from 'ngx-bootstrap-growl';
// services imports
import { ServerMapping } from './service/serverMapping.service';
import { Locale } from './service/locale.service';
import { AccountService } from './service/accountService.service';
import { Status } from './service/status.service';
import { SupplierService } from './service/supplierService.service';
import { CustomizingService } from './service/customizingService.service';
import { LabelFormatService } from './service/labelFormatService.service';
import { GrowlManager } from './manager/growl.manager';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    providers: [Exposer,
                Status,
                ServerMapping,
                AccountService,
                CustomizingService,
                SupplierService,
                LabelFormatService]
})
export class AppComponent extends Module implements OnInit {

    // variable declaration
    public isUserLogged                 = false;
    public actualAppZone 			    = '';
    public sidebarActive 			    = false;
    public showMobileMenu               = false;
    public userActionsMenuActive 	    = false;

    private customizingService: CustomizingService;
    private status: Status;
    private locale: Locale;
    private accountService: AccountService;

    public change_password_show = false;

    // constructor
    constructor(private mainExposer: Exposer
    ) {
        super();
        this.setBindExposer(mainExposer);
        this.customizingService = this.getExposer().getCustomizingService();
        this.status = this.getExposer().getStatus();
        this.locale = this.getExposer().getLocale();
        this.accountService = this.getExposer().getAccountService();

        this.customizingService.loadCustomizing();
        this.status.setAppComponent(this);
        let token = this.getParameterByName('token');
        if (!!token) {
            this.accountService.doTokenLogin(token);
        }
    }

    // block the browser back button
    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
        history.pushState(null, null, '#');
    }

    // close the user actions menù
    closeUserActionsMenuIfActive() {
        if (this.userActionsMenuActive === true) {
            this.userActionsMenuActive = false;
        }
    }

    // set the starting module during the instanciaton of the page
    ngOnInit() {
        this.actualAppZone = this.status.getLandingPage();
        this.change_password_show = this.customizingService.getBoolean('SERVICE.LOGIN.RESET_PASSWORD.ENABLE', 'FALSE');
    }

    onLogin(value: boolean) { this.isUserLogged = value; }

    // method that returns the title of the page selected by the user
    getTranslatedPageTitle() {
        if (this.actualAppZone === 'home') {
            return this.locale.getTerms().index.HOME;
        } else if (this.actualAppZone === 'material_list') {
            return this.locale.getTerms().index.MATERIAL_LIST;
        /*} else if (this.actualAppZone === 'bom_explosion') {
            return this.locale.getTerms().index.BOM_EXPLOSION;*/
        } else if (this.actualAppZone === 'order') {
            return this.locale.getTerms().index.ORDER;
        } else if (this.actualAppZone === 'delivery') {
            return this.locale.getTerms().index.DELIVERY;
        } else if (this.actualAppZone === 'stock') {
            return this.locale.getTerms().index.STOCK;
        } else if (this.actualAppZone === 'lot') {
            return this.locale.getTerms().index.LOT;
        } else if (this.actualAppZone === 'supply-doc') {
            return this.locale.getTerms().index.SUPPLY_DOC;
        }
    }

    appZoneChanged(newModuleSelected) {
        this.actualAppZone = newModuleSelected;
        this.sidebarActive = false;
    }

    toggleSidebar() {
        this.sidebarActive = !this.sidebarActive;
        this.status.setSidebarStatus(this.sidebarActive);
    }

    toggleUserActionsMenu(force: boolean) {
        if (force === true) {
            setTimeout(() => this.userActionsMenuActive = true, 5);
        } else if (this.userActionsMenuActive === false) {
            setTimeout(() => this.userActionsMenuActive = true, 1);
        } else {
            setTimeout(() => this.userActionsMenuActive = false, 1);
        }
    }

    doLogout() {
        this.accountService.doLogout();
    }

    getTerms()                      { return this.locale.getTerms(); }
    getMiscTerms()                  { return this.locale.getMiscTerms(); }
    getCurrentLanguageIconUrl()     { return this.locale.getCurrentLanguageIconUrl(); }
    changeLanguage()                { this.locale.changeLanguage(); }
    isManager()                     { return this.status.getIsManager(); }
    isAgent()                       { return this.status.getIsAgent(); }
    isDirectionalUser()             { return this.status.getIsDirectionalUser(); }
    isAnAgentSelected()             { return this.status.getAgentSelected(); }
    isACustomerSelected()           { return this.status.getClientSelected(); }

    getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        let fullPath = decodeURIComponent(results[0].replace('?', ''));
            //SS 03.02.2023 token is now dummy expedient
        const token = fullPath.substring(fullPath.indexOf("token=") + "token=".length, fullPath.length);
        
        return token;
    }

    
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts